// Funktion zum Manipulieren des Shadow-DOMS der Shopify-Forms-App
const changeShopifyFormsCSS = () => {
  const observer = new MutationObserver((mutations, obs) => {
    const formsEmbed = document.querySelector('shopify-forms-embed');

    if (formsEmbed && formsEmbed.shadowRoot) {
      if (!formsEmbed.shadowRoot.querySelector('.custom-border-fix')) {
        const style = document.createElement('style');
        style.classList.add('custom-border-fix');
        
        // durch eine JS-Injection das Shopify-Formular an mein Layout anpassen
        style.textContent = `
            #first_name, #last_name, #email, button[type="button"], textarea {
                color: #3d2e24 !important;
                font: normal 400 1rem Poppins, sans-serif !important;
            }
            #emailConsent-true-label > span, p {
                color: #3d2e24 !important;
                font: normal 400 0.8rem Poppins, sans-serif !important;
            }
            button[type="submit"] { 
                color: #3d2e24 !important;
                border: 1px solid #3d2e24 !important; 
                border-radius: var(--button-border-radius, 4px) !important;
                padding: var(--button-padding, 12px) !important;
                font: normal 400 1rem Poppins, sans-serif !important;
                transition: opacity 0.2s ease-in-out;
                background-color: white !important; 
            }
            button[type="submit"]:hover {
                background-color: #00000008 !important;
            }
        `;
        
        formsEmbed.shadowRoot.appendChild(style);
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
};

// Sofort ausführen
changeShopifyFormsCSS();